<template>
    <div>
        <!-- Navigation -->
        <div class="mb-4 d-flex justify-content-between">
            <div>
                <a :href="previousUrl" class="ix-absence-table-navigation-button">
                    <i class="far fa-angle-left"></i>
                </a>
                <a :href="nextUrl" class="ix-absence-table-navigation-button">
                    <i class="far fa-angle-right"></i>
                </a>

                <form method="GET" class="d-inline-block ml-4" id="dateForm">
                    <div class="ix-datepicker-wrapper">
                        <input type="text" class="form-control datepicker" id="date" v-model="selectedDate" name="date">
                    </div>
                </form>
            </div>

            <div class="ix-switcher" v-if="canManage">
                <button @click="changeChargeAttribute('value')" class="ix-switcher-item" v-bind:class="{'active': chargeAttribute == 'value'}">Valorisation</button>
                <button @click="changeChargeAttribute('volume')" class="ix-switcher-item" v-bind:class="{'active': chargeAttribute == 'volume'}">
                    Volume de travail
                    <span v-if="volumeUnit">({{ volumeUnit }})</span>
                </button>
            </div>
        </div>

        <!-- Create form -->
        <div class="modal fade" id="createScheduleFormModal" tabindex="-1" aria-labelledby="createScheduleFormModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ajouter une charge</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="formDateAt">Date</label>
                            <div class="ix-datepicker-wrapper">
                                <input type="text" class="form-control datepicker" placeholder="jj/mm/aaaa" id="formDateAt" v-model="form.date_at">
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="formLot">Lot</label>
                            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="formLot" type="text" v-model="form.search">
                        </div>

                        <div class="ix-checking-scan-lot-preview" v-if="form.lot">
                            <div class="ix-checking-scan-lot-preview-left">
                                <span class="ix-checking-scan-lot-preview-designation">{{ form.lot.designation }} <i class="far fa-boxes-alt"></i> {{ form.lot.quantity }}</span>
                                <span class="ix-checking-scan-lot-preview-deal">{{ form.lot.deal.designation }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer" v-if="canManage">
                        <button type="submit" class="ix-btn green" :disabled="loadingForm || (!form.lot || !form.date_at)" @click="store">
                            <span v-if="!loadingForm">Ajouter</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Detail sidebar -->
        <div class="ix-sidebar ix-sidebar-large" id="schedule-sidebar">
            <div class="ix-sidebar-header">
                <h2 class="ix-sidebar-title">Détails</h2>
                <button class="ix-sidebar-btn-close trigger-close-sidebar">
                    <i class="fal fa-times"></i>
                </button>
            </div>

            <div class="ix-sidebar-content" v-if="selectedSchedule">

                <a :href="lot_url" class="ix-checking-scan-lot-preview">
                    <div class="ix-checking-scan-lot-preview-left">
                        <span class="ix-checking-scan-lot-preview-designation">{{ selectedSchedule.lot.designation }} <i class="far fa-cube"></i> {{ selectedSchedule.lot.quantity }}</span>
                        <span class="d-block" v-if="selectedSchedule.lot.expected_at"><i class="far fa-calendar"></i> {{ selectedSchedule.lot.expected_at }}</span>
                        <span class="d-block ix-text-bold" v-if="selectedSchedule.lot.company">{{ selectedSchedule.lot.company }}</span>
                        <span class="ix-checking-scan-lot-preview-deal">{{ selectedSchedule.deal.designation }}</span>
                        <span class="d-block my-2" v-if="selectedSchedule.lot.description" v-html="nl2br(selectedSchedule.lot.description)"></span>
                        <div v-if="canManage">
                            <span v-if="chargeAttribute == 'volume' && selectedSchedule.lot.volume != null">{{ selectedSchedule.lot.volume + ` ${volumeUnit}` }}</span>
                            <span v-if="chargeAttribute == 'value' && selectedSchedule.lot.value != null">{{ currency(selectedSchedule.lot.value) }}</span>
                        </div>
                    </div>
                </a>

                <div class="my-4">
                    <div class="ix-comments-loader" v-if="loadingOperations">
                        <i class="far fa-circle-notch fa-spin"></i> Chargement de la chronologie
                    </div>

                    <div class="ix-operations-timeline " v-if="operations.length > 0 && !loadingOperations">
                        <div class="ix-operations-timeline-item" v-for="operation in operations" v-bind:key="'operation_' + operation.id">
                            <div class="ix-operations-timeline-item-decoration" v-bind:class="{'current': operation.state == 2, 'grey': operation.state == 1}">
                                <div class="ix-operations-timeline-item-circle">
                                    <span class="ix-operations-timeline-item-circle-dot" v-if="operation.state == 2"></span>
                                </div>
                                <div class="ix-operations-timeline-item-decoration-top"></div>
                                <div class="ix-operations-timeline-item-decoration-bottom"></div>
                            </div>

                            <div class="ix-operations-timeline-item-content" v-bind:class="{'current': operation.state == 2, 'opacity': operation.state == 1}">
                                <div class="ix-operations-timeline-item-content-head">
                                    <span class="ix-text-large">{{ operation.designation }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <a :href="lot_url">Accéder à l'ensemble des informations du lot</a>

                <div class="ix-checking-sidebar-actions mt-4" v-if="canManage">
                    <button type="button" class="ix-btn ix-btn-block transparent" v-bind:disabled="loadingDelete" @click="destroy(selectedSchedule)">
                        <span v-if="!loadingDelete"><i class="far fa-trash"></i> Supprimer</span>
                        <span v-if="loadingDelete"><i class="far fa-circle-notch fa-spin"></i> Suppression en cours</span>
                    </button>
                </div>
            </div>
        </div>
        
        <!-- Board -->
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement du planning
        </div>

        <div class="ix-kanban" id="board" v-show="loading == false">
            <div v-for="(column, index) in columns" :key="index" class="ix-kanban-column" v-bind:class="{'ix-kanban-column-accent-blue': column.is_today}">
                <div class="ix-kanban-column-header">
                    <span class="ix-text-capitalize">{{ column.label }} </span>
                    <span class="d-block ix-text-small ix-text-secondary">{{ column.date }}</span>
                </div>

                <draggable tag="div" class="ix-kanban-column-content" :list="column.schedules" group="schedules" @change="onCardChange(column, $event)" v-bind="dragOptions">
                    <div class="ix-kanban-card trigger-sidebar" v-for="(schedule, sIndex) in column.schedules" :key="sIndex" v-bind:class="schedule.lot.state_color" @click="openSchedule(schedule)">
                        <div class="ix-kanban-card-content opacity">
                            <span class="ix-text-bold">{{ schedule.lot.designation }}</span>
                            <span class="d-block ix-text-small" v-if="schedule.lot.expected_at"><i class="far fa-calendar"></i> {{ schedule.lot.expected_at }}</span>
                            <span class="d-block ix-text-small ix-text-bold" v-if="schedule.lot.company">{{ schedule.lot.company }}</span>
                            <span class="d-block ix-text-small">{{ schedule.deal.designation }}</span>
                            <span class="d-block ix-text-small" v-if="schedule.lot.description" v-html="truncate(schedule.lot.description, 40)"></span>

                            <div v-if="canManage" class="ix-text-small">
                                <span v-if="chargeAttribute == 'volume' && schedule.lot.volume != null">{{ schedule.lot.volume + ` ${volumeUnit}` }}</span>
                                <span v-if="chargeAttribute == 'value' && schedule.lot.value != null">{{ currency(schedule.lot.value) }}</span>
                            </div>
                        </div>
                    </div>
                </draggable>

                <div class="ix-kanban-column-footer" v-if="canManage">
                    <div class="ix-kanban-column-footer-indicator">
                        {{ chargeAttribute == 'volume' ? getCharge(column) + ` ${volumeUnit}` : currency(getCharge(column)) }}
                    </div>

                    <div class="ix-kanban-column-footer-actions">
                        <button class="ix-btn ix-btn-small blue ix-btn-block trigger-sidebar" @click="create(column.date)">Ajouter</button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import draggable from 'vuedraggable';

    export default {
        name: 'schedules-kanban',
        props: ['previousUrl', 'nextUrl', 'url', 'date', 'volumeUnit', 'lotsRoute', 'lotDetailRoute', 'canManage', 'defaultChargeAttr'],
        components: { draggable },
        computed: {
            dragOptions() {
                return {
                    animation: 0,
                    group: "schedules",
                    disabled: !this.canManage,
                    ghostClass: "ghost"
                };
            },
            lot_url: function() {
                let url = ''

                if (this.selectedSchedule) {
                    url = this.lotDetailRoute.replace('##', this.selectedSchedule.deal.id).replace('??', this.selectedSchedule.lot.id)
                }

                return url;
            },
        },
        data() {
            return {
                loading: true,
                loadingForm: false,
                loadingDelete: false,
                loadingOperations: false,
                selectedDate: this.date,
                chargeAttribute: this.defaultChargeAttr,
                columns: [],
                operations: [],
                
                form: {
                    date_at: null,
                    search: null,
                    lot: null
                },

                selectedSchedule: null,

                instance: Math.random().toString(36).substr(2, 9)
            };
        },
        methods: {
            startListening: function(){
                let domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];

                Echo.channel(`${domain}.schedules`)
                    .listen('.schedule-entered-in-day', (e) => {
                        if (e.instance != this.instance) {
                            this.addScheduleAtIndexInDay(e.schedule, e.index, e.date);
                        }
                    })
                    .listen('.schedule-removed-from-day', (e) => {
                        if (e.instance != this.instance) {
                            this.removeScheduleAtIndexInDay(e.index, e.date);
                        }
                        
                    })
                    .listen('.schedule-moved-in-day', (e) => {
                        if (e.instance != this.instance) {
                            this.moveScheduleFromIndexToIndexInDay(e.schedule, e.oldIndex, e.newIndex, e.date);
                        }
                    })
            },
            stopListening: function(){
                Echo.leaveChannel('schedules');
            },
            addScheduleAtIndexInDay: function(schedule, index, day) {
                let colIndex = this.getColIndexByDate(day);
                if (colIndex >= 0) {
                    this.columns[colIndex].schedules.splice(index, 0, schedule);
                }
            },
            removeScheduleAtIndexInDay: function(index, day) {
                let colIndex = this.getColIndexByDate(day);
                if (colIndex >= 0) {
                    this.columns[colIndex].schedules.splice(index, 1);
                }
            },
            moveScheduleFromIndexToIndexInDay: function(schedule, fromIndex, toIndex, day) {
                let colIndex = this.getColIndexByDate(day);
                if (colIndex >= 0) {
                    this.columns[colIndex].schedules.splice(fromIndex, 1);
                    this.columns[colIndex].schedules.splice(toIndex, 0, schedule);
                }
            },
            getColIndexByDate: function(date) {
                return this.columns.findIndex(col => {
                    return col.date == date;
                });
            },
            getCharge(column) {
                return column.schedules.reduce((a, b) => a + (b['lot'][this.chargeAttribute] || 0), 0);
            },
            changeChargeAttribute(attr) {
                this.chargeAttribute = attr
            },
            onCardChange: function(column, e) {
                if (e.added || e.moved) {
                    let key = e.moved ? 'moved' : 'added';

                    let newDate = null;
                    let newIndex = e[key].newIndex;
                    let el = e[key].element;

                    if (e.added) {
                        newDate = column.date;
                    }

                    el.date_at = column.date // Ne pas utiliser newDate

                    this.move(el.id, newIndex, newDate);
                }
            },
            pushToBoard: function(schedule) {
                let columnIndex = this.columns.findIndex(col => {
                    return col.date == schedule.date_at;
                })

                if(columnIndex >= 0) {
                    this.columns[columnIndex].schedules.push(schedule)
                } else {
                    window.location.href = window.location.href.split(/[?#]/)[0] + `?date=${schedule.date_at}`;
                }
            },
            removeFromBoard: function(schedule) {
                let columnIndex = this.columns.findIndex(col => {
                    return col.date == schedule.date_at;
                })

                if(columnIndex >= 0) {
                    let scheduleIndex = this.columns[columnIndex].schedules.findIndex(sch => {
                        return sch.id == schedule.id;
                    })

                    if (scheduleIndex >= 0) {
                        this.columns[columnIndex].schedules.splice(scheduleIndex, 1);
                    }
                }
            },
            initForm: function() {
                this.form.date_at = null;
                this.form.search = null;
                this.form.lot = null;
            },
            create: function(date) {
                if (date != null) {
                    $("#formDateAt").datepicker('setDate', date);
                    this.form.date_at = date;
                }

                $('#createScheduleFormModal').modal()
            },
            store: async function() {
                this.loadingForm = true

                fetch(this.url, {
                    ...{
                        method: 'POST',
                        body :  JSON.stringify({date_at: this.form.date_at, lot_id: this.form.lot.id, instance: this.instance})
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    this.loadingForm = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            $('#createScheduleFormModal').modal('hide');
                            this.initForm();
                            this.pushToBoard(data)
                        })
                    }
                }).catch(error => {
                    this.loadingForm = false
                    console.log(error)
                });
            },
            move: async function(id, index, date) {
                fetch(this.url + `/${id}/move`, {
                    ...{
                        method: 'PUT',
                        body :  JSON.stringify({index: index, date_at: date, instance: this.instance})
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status != 200) {
                        console.log('Server error');
                    }
                }).catch(error => {
                    console.log(error)
                });
            },
            getData: async function(){
                this.loading = true;
                fetch(this.url + window.location.search, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loading = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.columns = data

                            setTimeout(() => {
                                $('#board').scrollLeft((document.getElementById('board').scrollWidth - $('#board').width()) / 2); 
                            }, 100)
                        })
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error)
                });
            },
            openSchedule: function(schedule) {
                this.selectedSchedule = schedule;
                this.operations = [];
                $('#schedule-sidebar').addClass('open');

                this.getScheduleLotOperations(schedule);
            },
            getScheduleLotOperations: async function(schedule) {
                this.loadingOperations = true;
                fetch(`/api/lots/${schedule.lot.id}/operations`, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loadingOperations = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.operations = data
                        })
                    }
                }).catch(error => {
                    this.loadingOperations = false;
                    console.log(error)
                });
            },
            destroy: async function(schedule) {
                this.loadingDelete = true;
                fetch(this.url + `/${schedule.id}`, {
                    ...{
                        method: 'DELETE',
                        body :  JSON.stringify({instance: this.instance})
                    },
                    ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    this.loadingDelete = false;
                    if (response.status == 200) {
                        this.removeFromBoard(schedule)
                        this.selectedSchedule = null;
                        this.operations = [];
                        $('#schedule-sidebar').removeClass('open');
                    }
                }).catch(error => {
                    this.loadingDelete = false;
                    console.log(error)
                });
            },
        },
        mounted() {
            $('#date').change(function() {
                // TODO :: Fix "Click sur Aujourdhui"
                $('#dateForm').submit()
            });

            $("#formLot").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.lotsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, states: '2,3,4' },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.form.search = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.form.lot = item.item;

                        $(e.target).val("");
                        this.form.search = null;
                    }
                }
            }).focus(() => {
                $("#formLot").autocomplete("search", '');
            });

            this.startListening()
            this.initForm()
            this.getData()
        }
    }
</script>
